<template>
    <div>
        <card-header title="Client Search" icon="fa-duotone fa-magnifying-glass" />

        <card-body>
            <card-list>
                <subheader-list-item :title="props.query" icon="fa-users" :badge="clients.length + ' Results'"></subheader-list-item>
                <reseller-client-tile v-for="client in clients" :card="card" :user="client"
                    @click="$openCard('user', { userId: client.id }, card)" />
            </card-list>
        </card-body>
    </div>
</template>

<script>
// tier items
import CardHeader from "@/TIER/components/CardHeader";
import CardBody from "@/TIER/components/CardBody";
import CardList from "@/TIER/components/CardList";
import SubheaderListItem from "@/TIER/components/SubheaderListItem";
import SearchListItem from "@/TIER/components/SearchListItem";
// components
import ResellerClientTile from "../../components/tiles/ResellerClientTile";
// js
import { axiosInstance as axios, apiUrl } from "@/http_client";

export default {
    components: {
        // tier items
        CardHeader, CardBody, CardList, SubheaderListItem, SearchListItem,
        // components
        ResellerClientTile
    },
    props: ['card', 'child', 'props'],
    data() {
        return {
            clients: [],
        };
    },
    methods: {
        formatUser(user) {
            // if no enrollments, set to 0
            if (!user.courseenrollments || !user.courseenrollments.length) {
                user.total_hours = 0;
                user.total_courses = 0;
                user.courses_started = 0;
                user.courses_completed = 0;
                return user;
            }
            // calc total hours
            user.total_hours = user.courseenrollments.reduce((total, enrollment) => {
                return total + enrollment.units;
            }, 0);
            // calc total courses
            user.total_courses = user.courseenrollments.length;
            // calc courses started
            user.courses_started = user.courseenrollments.reduce((total, enrollment) => {
                return total + (enrollment.logtime > 0 ? 1 : 0);
            }, 0);
            // calc courses completed
            user.courses_completed = user.courseenrollments.reduce((total, enrollment) => {
                return total + (enrollment.completed ? 1 : 0);
            }, 0);
            return user;
        },
        searchClients() {
            this.$emit('loading', true);
            axios.get(`${apiUrl}resellers/clients/search/${this.props.query}/0/50`).then(response => {
                this.clients.push(...response.data.map(client => this.formatUser(client)));
                this.$emit('loading', false);
            });
        },
    },
    watch: {
        'props.query': () => {
            this.searchClients();
        },
    },
    mounted() {
        this.searchClients();
    },
}
</script>